import { usePromotionalBannerList } from '@/features/promos-offer/promotional-banner/hooks/usePromotionalBannerList';
import { PromotionalBannerTable } from '@/features/promos-offer/promotional-banner/table';
import { createFileRoute, SearchSchemaInput } from '@tanstack/react-router';
import { z } from 'zod';

const sortItemSchema = z.object({
  id: z.enum(['title', 'description', 'status', 'createdDate']),
  desc: z.boolean(),
});

const promotionBannerSchema = z.object({
  sort: z
    .preprocess((val) => {
      if (typeof val === 'string') {
        try {
          return JSON.parse(val);
        } catch {
          return undefined;
        }
      }
      return val;
    }, z.array(sortItemSchema))
    .optional(),
  createdDate: z
    .string()

    .optional(),

  q: z
    .any()
    .transform((val) => (val == null ? undefined : String(val)))
    .optional(),

  status: z
    .string()
    .transform((val) => val.split(','))
    .pipe(z.array(z.enum(['ACTIVE', 'INACTIVE'])))
    .optional(),

  page: z.coerce.number().positive().catch(0),
  fetch: z.coerce.number().positive().max(100).catch(10),
});

export const Route = createFileRoute('/(app)/promos-offer/promotional-banner/')({
  component: RouteComponent,
  validateSearch: (search: SearchSchemaInput) => promotionBannerSchema.parse(search),
});

function RouteComponent() {
  const { promotionalBanner, isLoading, pagination } = usePromotionalBannerList();
  return <PromotionalBannerTable data={promotionalBanner} pagination={pagination} loading={isLoading} />;
}
